/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import AttributeValues from "./AttributeValues";
import Open5eDocument from "./Open5eDocument";
import SavingThrows from "./SavingThrows";
import Speed from "./Speed";

export class MonsterOpen5e implements AttributeValues, SavingThrows, Open5eDocument {
    slug:                   string = "";
    desc:                   string = "";
    name:                   string = "Default Monster";
    size:                   string = "Medium";
    type:                   string = "Humanoid";
    subtype:                string = "";
    group:                  string = "";
    alignment:              string = "Neutral";
    armor_class:            number = 10;
    armor_desc:             string = "";
    hit_points:             number = 5;
    hit_dice:               string = "1d8"; /*16d10+64*/
    speed:                  Speed  = new Speed();
    strength:               number = 10;
    dexterity:              number = 10;
    constitution:           number = 10;
    intelligence:           number = 10;
    wisdom:                 number = 10;
    charisma:               number = 10;
    strength_save:          number | null = null;
    dexterity_save:         number | null = null;
    constitution_save:      number | null = null;
    intelligence_save:      number | null = null;
    wisdom_save:            number | null = null;
    charisma_save:          number | null = null;
    perception:             number = 0;
    skills:                 Map<string, number> = new Map();
    damage_vulnerabilities: string = "";
    damage_resistances:     string = "";
    damage_immunities:      string = "";
    condition_immunities:   string = "";
    senses:                 string = ""; /*blindsight 30 ft., darkvision 120 ft., passive Perception 19"*/
    languages:              string = "Common"; /*"Common, Draconic",*/
    challenge_rating:       string = "1";
    cr:                     number = 1.0;
    actions:                Ability[] = []; /*[{name, desc, attack_bonus, damage_dice, damage_bonus}, ...]*/
    bonus_actions:          Ability[] = []; /*null*/
    reactions:              Ability[] = [];
    legendary_desc:         string = "";
    legendary_actions:      Ability[] = [];
    special_abilities:      Ability[] = [];
    spell_list:             string[] = [];
    page_no:                number = 0;
    environments:           string[] = []; /*["Desert","Coastal"],*/
    img_main:               string | null = null;
    document__slug:         string = "";
    document__title:        string = "";
    document__license_url:  string = "";
    document__url:          string = "";
}

    const wereboar = new MonsterOpen5e();
    wereboar.slug = "wereboar";
    wereboar.desc = "",
    wereboar.name = "Wereboar";
    wereboar.size = "Medium";
    wereboar.type = "Humanoid";
    wereboar.subtype = "human";
    wereboar.group = "Lycanthropes";
    wereboar.alignment = "neutral evil";
    wereboar.armor_class = 10;
    wereboar.armor_desc = "10 in humanoid form, 11 (natural armor) in boar or hybrid form";
    wereboar.hit_points = 78;
    wereboar.hit_dice = "12d8+24";
    wereboar.speed = new Speed();
    wereboar.speed.notes = "40 ft. in boar form";
    wereboar.speed.walk = 30;
    wereboar.strength = 17;
    wereboar.dexterity = 10;
    wereboar.constitution = 15;
    wereboar.intelligence = 10;
    wereboar.wisdom = 11;
    wereboar.charisma = 8;
    wereboar.strength_save = null;
    wereboar.dexterity_save = null;
    wereboar.constitution_save = null;
    wereboar.intelligence_save = null;
    wereboar.wisdom_save = null;
    wereboar.charisma_save = null;
    wereboar.perception = 2;
    wereboar.skills.set("perception", 2);
    wereboar.damage_vulnerabilities = "";
    wereboar.damage_resistances = "";
    wereboar.damage_immunities = "bludgeoning, piercing, and slashing from nonmagical attacks not made with silvered weapons";
    wereboar.condition_immunities = "";
    wereboar.senses = "passive Perception 12";
    wereboar.languages = "Common (can't speak in boar form)";
    wereboar.challenge_rating = "4";
    wereboar.cr = 4.0;
    wereboar.actions = [
        {
            "name": "Multiattack (Humanoid or Hybrid Form Only)",
            "desc": "The wereboar makes two attacks, only one of which can be with its tusks."
        },
        {
            "name": "Maul (Humanoid or Hybrid Form Only)",
            "desc": "Melee Weapon Attack: +5 to hit, reach 5 ft., one target. Hit: 10 (2d6 + 3) bludgeoning damage.",
            // "attack_bonus": 5,
            // "damage_dice": "2d6",
            // "damage_bonus": 3
        },
        {
            "name": "Tusks (Boar or Hybrid Form Only)",
            "desc": "Melee Weapon Attack: +5 to hit, reach 5 ft., one target. Hit: 10 (2d6 + 3) slashing damage. If the target is a humanoid, it must succeed on a DC 12 Constitution saving throw or be cursed with wereboar lycanthropy.",
            // "attack_bonus": 5,
            // "damage_dice": "2d6",
            // "damage_bonus": 3
        }
    ],
    wereboar.bonus_actions = [];
    wereboar.reactions = [];
    wereboar.legendary_desc = "";
    wereboar.legendary_actions = [];
    wereboar.special_abilities = [
        {
            "name": "Shapechanger",
            "desc": "The wereboar can use its action to polymorph into a boar-humanoid hybrid or into a boar, or back into its true form, which is humanoid. Its statistics, other than its AC, are the same in each form. Any equipment it is wearing or carrying isn't transformed. It reverts to its true form if it dies."
        },
        {
            "name": "Charge (Boar or Hybrid Form Only)",
            "desc": "If the wereboar moves at least 15 feet straight toward a target and then hits it with its tusks on the same turn, the target takes an extra 7 (2d6) slashing damage. If the target is a creature, it must succeed on a DC 13 Strength saving throw or be knocked prone.",
            // "attack_bonus": 0,
            // "damage_dice": "2d6"
        },
        {
            "name": "Relentless (Recharges after a Short or Long Rest)",
            "desc": "If the wereboar takes 14 damage or less that would reduce it to 0 hit points, it is reduced to 1 hit point instead."
        }
    ],
    wereboar.spell_list = [];
    wereboar.page_no = 327;
    wereboar.environments = [
        "Hill",
        "Grassland",
        "Forest",
        "Jungle",
        "Hills",
        "Shadowfell",
        "Feywild",
        "Settlement"
    ],
    wereboar.img_main = null;
    wereboar.document__slug = "wotc-srd";
    wereboar.document__title = "5e Core Rules";
    wereboar.document__license_url = "http://open5e.com/legal";
    wereboar.document__url = "http://dnd.wizards.com/articles/features/systems-reference-document-srd";

export default MonsterOpen5e;